theme.SlideShow = (function() {
  function Slider(e) {
    let slideshow = e.querySelector(".slideshow__wrapper"),
        paginationSelector = e.querySelector('.swiper-pagination'),
        navselectorPrev = e.querySelector('.swiper-button-prev'),
        navselectorNext = e.querySelector('.swiper-button-next'),
        autoplaySelctor = e.dataset.sliderAutoplay,
        autoplayInit = false,
        autoPlayDelay = parseInt(e.dataset.sliderDelay),
        loopSelector = e.dataset.sliderLoop,
        loopInit = false,
        slidePagination = e.dataset.pagination,
        paginatinInit = "bullets",
        swiperItem = e.querySelectorAll('.swiper-slide');
        
    
    if(autoplaySelctor == "true"){
    	autoplayInit = 	{delay: autoPlayDelay}
    }
    if(loopSelector == "true"){
    	loopInit = true;
    }
    
    if(slidePagination == "counter"){
    	paginatinInit = "fraction"
    }
    
	var swiper = new Swiper(slideshow, {
      loop: loopInit,
      pagination: {
        el: paginationSelector,
        clickable: true,
        type: paginatinInit,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
        }
      },
      autoplay: autoplayInit,
      autoHeight: true,
      navigation: {
        nextEl: navselectorNext,
        prevEl: navselectorPrev,
      }
    });

    if (Shopify.designMode) {
      function onBlockSelect(event){
        const blockId = event.detail.blockId;
        swiperItem.forEach((item)=>{
          const ItemBlockId = item.getAttribute('data-block-id')
          if(blockId === ItemBlockId){
            const swiperItemIndex = item.getAttribute("data-slide-index")
            swiper.slideTo(swiperItemIndex)
            sessionStorage.setItem('selectedSlideIndex', swiperItemIndex)
          }
        })
      }
  
      function onSectionLoad(event){
          const getSwiperItemIndex = sessionStorage.getItem('selectedSlideIndex')
          swiper.slideTo(getSwiperItemIndex)
      }
  
      document.addEventListener('shopify:block:select', onBlockSelect);
      document.addEventListener('shopify:block:deselect', onBlockSelect);
      document.addEventListener('shopify:section:load', onSectionLoad);
      document.addEventListener('shopify:section:select', onSectionLoad);
    }
  }
  return Slider;
})();